<template>
  <Layout>
    <div v-if="userData.permissions['view_sms_center'] == 1">
      <div class="row">
        <div class="col-sm-3">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-muted fw-medium mb-2">
                    SMS Sent
                  </p>
                  <h4 class="mb-0">
                    {{ commas(membermessages + staffmessages + other_messages) }}
                  </h4>
                </div>
                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                  <span class="avatar-title"><i class="mdi mdi-telegram font-size-24"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-muted fw-medium mb-2">
                    SMS to Members
                  </p>
                  <h4 class="mb-0">
                    {{
                      commas(
                        membermessages
                      )
                    }}
                  </h4>
                </div>
                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                  <span class="avatar-title"><i class="mdi mdi-account font-size-24"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-muted fw-medium mb-2">
                    SMS to Staff
                  </p>
                  <h4 class="mb-0">
                    {{ commas(staffmessages) }}
                  </h4>
                </div>
                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                  <span class="avatar-title"><i class="mdi mdi-account-tie font-size-24"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-muted fw-medium mb-2">
                    SMS to Others
                  </p>
                  <h4 class="mb-0">
                    {{ commas(other_messages) }}
                  </h4>
                </div>
                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                  <span class="avatar-title"><i class="mdi mdi-account-multiple font-size-24"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="row align-items-center">
          <div class="col fw-medium my-1 ms-3">
            SMS Balance: <span class="fs-5 text-success">{{ commas(sms_balance) }}</span>
          </div>
        </div>

        <!-- <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                  <span class="avatar-title"><i class="mdi mdi-message-bulleted font-size-24"></i></span>
                </div> -->
      </div>
      <div class="card shadow-sm">
        <div class="card-body p-2">
          <b-tabs pills vertical nav-class="p-0" content-class="text-dark">
            <b-tab active v-if="userData.permissions['send_to_members'] == 1" class="border-0">
              <template v-slot:title>SMS to Member</template>
              <div class="card p-0">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3">
                      <div class="row p-2 shadow-sm">
                        <select @change="getAllMembers" class="form-control" v-model="member_category"
                          placeholder="Select Member Category">
                          <option value="" disabled selected> Select Category</option>
                          <option value="1">All Members</option>
                          <option value="2">Specific Members</option>
                        </select>

                        <button @click.prevent="removeAllMembers" class="mt-2 btn btn-sm btn-danger">Clear All</button>
                      </div>
                      <form @submit.prevent="addMember">
                        <br>
                        <div class="row" v-if="false">
                          <div class="col-md-9 pe-0">

                            <label>Members</label>
                            <v-select :options="members" placeholder="Select a Member" v-model="member" label="name"
                              :reduce="(member) =>
                                member.member_id
                                "></v-select>

                          </div>
                          <div class="col-md-3 mt-4 ps-0">
                            <b-button type="submit" :disabled="sms_balance <= 0
                              " class="btn ms-1 w-100" variant="primary"><i class="fas fa-plus-circle"></i></b-button>
                          </div>
                        </div>
                      </form>
                      <div v-if="member_category == 2">
                        <div class="scrollable-list">
                          <div class="pb-1" v-for="(member, index) in members" :key="index">
                            <input @change.prevent="selectMembers(member.member_id, $event)" type="checkbox"> {{
                              member.name }}
                          </div>
                        </div>
                        <button @click="addMember" class="mt-1 w-100 btn btn-primary btn-sm">Add Members</button>
                      </div>
                    </div>
                    <div class="col-md-9 p-3 shadow-lg">
                      <form @submit.prevent="sendtoMember">
                        <div class="row">
                          <span class="col-md-4 rounded-2 p-1" v-for="item in smsmembers" :key="item.id">
                            <b class="text-black">{{
                              item.member.name
                            }}</b>
                            &nbsp;
                            <small>{{
                              item.member
                                .telephone
                            }}</small>
                            &nbsp;
                            <b-button @click="
                              removeSmsMember(
                                item.id,
                              )
                              " type="button" class="btn-sm btn rounded-3 py-0 px-1" variant="danger" v-b-modal.delete>
                              <i class="mdi mdi-close"></i>
                            </b-button>
                          </span>

                        </div>
                        <label>Message</label>
                        <small class="text-danger">(Will start with:
                          {{
                            userData.business
                          }}:)</small>
                        <textarea v-model="msg1" rows="4" @input="CalcSMS1" class="form-control"></textarea>
                        <small class="text-muted">
                          Characters:
                          <b class="text-primary h5">{{ chars1 }}</b>
                          &nbsp;&nbsp;&nbsp; SMS:
                          <b class="text-primary h5">{{ sms1 }}</b>
                        </small>
                        <b-button type="submit" :disabled="sms_balance <= 0 ||
                          sendbtn1 <= false ||
                          smsmembers.length <=
                          0
                          " class="btn ms-1 w-100" variant="primary"><i class="fas fa-check-circle"></i>
                          SEND</b-button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab class="border-0" v-if="userData.permissions['send_to_staff'] == 1">
              <template v-slot:title>SMS to Staff</template>
              <div class="card p-0">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3">
                      <div class="row p-2 shadow-sm">
                        <select @change="getAllStaff" class="form-control" v-model="staff_category"
                          placeholder="Select Member Category">
                          <option value="" disabled selected> Select Category</option>
                          <option value="1">All Staff</option>
                          <option value="2">Specific Staff</option>
                        </select>
                        <button @click.prevent="removeAllStaff" class="mt-2 btn btn-sm btn-danger">Clear All</button>
                      </div>
                      <form @submit.prevent="addStaff">
                        <div v-if="staff_category == 2" class="row">
                          <div class="col-md-9 pe-0">
                            <label>Staff
                              Members</label>
                            <v-select :options="users" placeholder="Select a User" v-model="staff"
                              label="username"></v-select>
                          </div>
                          <div class="col-md-3 mt-4 ps-0">
                            <b-button type="submit" :disabled="sms_balance <= 0
                              " class="btn ms-1 w-100" variant="primary"><i class="fas fa-plus-circle"></i></b-button>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div class="col-md-9 p-3 shadow-lg">
                      <form @submit.prevent="sendtoStaff">
                        <div class="row">
                          <span class="col-md-4 rounded-2 p-1" v-for="item in smsstaffs" :key="item.id">
                            <b class="text-black">{{
                              item.member.name
                            }}</b>
                            &nbsp;
                            <small>{{
                              item.member
                                .telephone
                            }}</small>
                            &nbsp;
                            <b-button @click="
                              removeSmsStaff(
                                item.id
                              )
                              " type="button" class="btn-sm btn rounded-3 py-0 px-1" variant="danger" v-b-modal.delete>
                              <i class="mdi mdi-close"></i>
                            </b-button>
                          </span>
                        </div>
                        <label>Message</label>
                        <small class="text-danger">(Will start with:
                          {{
                            userData.business
                          }}:)</small>
                        <textarea v-model="msg2" rows="4" @input="CalcSMS2" class="form-control"></textarea>
                        <small class="text-muted">
                          Characters:
                          <b class="text-primary h5">{{ chars2 }}</b>
                          &nbsp;&nbsp;&nbsp; SMS:
                          <b class="text-primary h5">{{ sms2 }}</b>
                        </small>
                        <b-button type="submit" :disabled="sms_balance <= 0 ||
                          sendbtn2 <= false ||
                          smsstaffs.length <=
                          0
                          " class="btn ms-1 w-100" variant="primary"><i class="fas fa-check-circle"></i>
                          SEND</b-button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab class="border-0" v-if="userData.permissions['send_to_others'] == 1">
              <template v-slot:title>SMS to Other</template>
              <div class="card p-0">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3 p-3">
                      <!-- <form @submit.prevent="addOther"></form> -->
                      <div class="">
                        <div class="fw-bold p-0 m-0">Enter Contacts
                        </div>
                        <small class="pt-0 mt-0 text-danger">
                          Start with 0 and
                          separate with ,</small>
                        <textarea @paste="addContactTag" @keyup="addContactTag" v-model="contact" id="contact"
                          class="form-control" rows="1"></textarea>
                        <div class="">
                          <span v-for="(contact,
                            index) in contacts" :key="index" class="badge rounded-pill text-light bg-dark fs-6 m-1">
                            {{ contact }}
                            <span @click="
                              removeEmailTag(
                                index
                              )
                              " class="text-danger fs-6"><i class="mdi mdi-window-close"></i></span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-9">
                      <div class="card shadow-lg">
                        <div class="p-3 card-body">
                          <form @submit.prevent="sendtoOthers">
                            <label>Message </label>
                            <small class="text-danger">
                              (Will start with:
                              {{
                                userData.business
                              }}:)</small>
                            <textarea v-model="msg3" rows="4" @input="CalcSMS3" class="form-control"></textarea>
                            <small class="text-muted">
                              Characters:
                              <b class="text-primary h5">{{ chars3 }}</b>
                              &nbsp;&nbsp;&nbsp; SMS:
                              <b class="text-primary h5">{{ sms3 }}</b>
                            </small>
                            <b-button type="submit" :disabled="sms_balance <= 0 ||
                              sendbtn3 <= false ||
                              contacts.length <=
                              0
                              " class="btn ms-1 w-100" variant="primary"><i class="fas fa-check-circle"></i>
                              SEND</b-button>
                          </form>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br /><br />
            <center>
              <span class="text-primary h6">You have no permission to View SMS Center</span>
            </center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="delete-smsmember" centered title="Delete Member" title-class="font-18" hide-footer>
      <form @submit.prevent="removeSmsMember">
        <input v-model="id" type="hidden" />
        Are you sure you want to delete the Member :
        <b>{{ membername }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('delete-smsmember')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            YES</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="delete-smsstaff" centered title="Delete Staff Member" title-class="font-18" hide-footer>
      <form @submit.prevent="removeSmsStaff">
        <input v-model="id" type="hidden" />
        Are you sure you want to delete the Staff Member :
        <b>{{ staffname }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('delete-smsstaff')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            YES</b-button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { memberMethods, memberComputed } from "@/state/helpers";
import { userMethods, userComputed } from "@/state/helpers";

export default {
  page: {
    title: "SMS Center",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      sms_balance: 0,
      membermessages: 0,
      staffmessages: 0,
      other_messages: 0,
      member: [],
      smsmembers: [],
      membername: "",
      id: "",
      staff: [],
      smsstaffs: [],
      staffname: "",
      staffid: "",
      chars1: 0,
      sms1: 0,
      msg1: "",
      sendbtn1: true,
      chars2: 0,
      sms2: 0,
      msg2: "",
      sendbtn2: true,
      chars3: 0,
      sms3: 0,
      msg3: "",
      sendbtn3: true,
      contacts: [],
      contact: "",
      member_category: '',
      staff_category: '',
      selected_members: [],
      selected_staff: 0
    };
  },
  computed: {
    ...memberComputed,
    ...userComputed,
    Items() {
      return this.member.map((d) => ({ name: d.name }));
    },
    Cart() {
      return this.smsmembers.map((d) => ({
        id: d.id,
        member_id: d.member.member_id,
        name: d.member.name,
        telephone: d.member.telephone,
      }));
    },
    StaffCart() {
      return this.smsstaffs.map((d) => ({
        id: d.id,
        member_id: d.member.member_id,
        name: d.member.name,
        telephone: d.member.telephone,
      }));
    },
  },
  mounted() {
    this.fetchMembers();
    this.fetchSMSMembers();
    this.fetchSMSStaffs();
    this.fetchUsers();
    this.showSmsanalysis();
  },
  methods: {
    ...memberMethods,
    ...userMethods,
    CalcSMS1() {
      this.chars1 = this.msg1.length;
      this.sms1 = Math.ceil(this.chars1 / 160) * this.smsmembers.length;
      if (this.sms_balance < this.sms1) {
        this.sendbtn1 = false;
      } else {
        this.sendbtn1 = true;
      }
    },
    CalcSMS2() {
      this.chars2 = this.msg2.length;
      this.sms2 = Math.ceil(this.chars2 / 160) * this.smsstaffs.length;
      if (this.sms_balance < this.sms2) {
        this.sendbtn2 = false;
      } else {
        this.sendbtn2 = true;
      }
    },

    CalcSMS3() {
      this.chars3 = this.msg3.length;
      this.sms3 = Math.ceil(this.chars3 / 160) * this.contacts.length;
      if (this.sms_balance < this.sms3) {
        this.sendbtn3 = false;
      } else {
        this.sendbtn3 = true;
      }
    },

    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // async addMember() {
    //   this.CalcSMS1();
    //   let formData = new FormData();
    //   formData.append("member", this.member);
    //   let url = "/addsmsmember";
    //   await axios.post(url, formData).then((response) => {
    //     if (response.status == 200) {
    //       this.member = "";
    //       this.fetchSMSMembers();
    //       this.$toast.success(response.data.message);
    //     }
    //   });
    // },
    async addMember() {
      this.CalcSMS1();
      let obj = {
        members: this.selected_members
      }
      let url = "/addsmsmembers";
      await axios.post(url, obj).then((response) => {
        if (response.status == 200) {
          this.member = "";
          this.fetchSMSMembers();
          this.$toast.success(response.data.message);
        }
      });
      this.member_category = ""
    },
    async fetchSMSMembers() {
      let url = "/smsmembers";
      await axios.get(url).then((response) => {
        this.smsmembers = response.data.members;
      });
    },
    removeMember(id, name) {
      this.id = id;
      this.membername = name;
      this.$bvModal.show("delete-smsmember");
    },

    async removeAllMembers() {
      await axios.get('clear-all-members').then(response => {
        if (response.status == 200) {
          this.$toast.success(response.data.message);
          this.fetchSMSMembers();
        } else {
          this.$toast.error(response.data.error)
        }
      })
    },

    async removeAllStaff() {
      await axios.get('clear-all-staff').then(response => {
        if (response.status == 200) {
          this.$toast.success(response.data.message);
          this.fetchSMSStaffs();
        } else {
          this.$toast.error(response.data.error)
        }
      })
    },

    async removeSmsMember(id) {
      this.id = id;
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removesmsmember";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSMSMembers();
          this.$bvModal.hide("delete-smsmember");
        }
      });
    },
    async sendtoMember() {
      let obj = { member: this.Cart, message: this.msg1, sms: this.sms1 };
      let url = "/sendtomember";
      await axios.post(url, obj).then((response) => {
        if (response.status == 200) {
          this.showSmsanalysis();
          this.fetchSMSMembers();
          this.msg1 = "";
          this.chars1 = "";
          this.sms1 = "";
          this.$toast.success(response.data.message);
        }
      });
    },

    async addStaff() {
      this.CalcSMS2();
      let formData = new FormData();
      formData.append("staff", this.staff.member.member_id);
      let url = "/addsmsstaff";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.staff = "";
          this.fetchSMSStaffs();
          this.$toast.success(response.data.message);
        }
      });
    },
    async fetchSMSStaffs() {
      let url = "/smsstaffs";
      await axios.get(url).then((response) => {
        this.smsstaffs = response.data.staffs;
      });
    },
    removeStaff(id, name) {
      this.id = id;
      this.staffname = name;
      this.$bvModal.show("delete-smsstaff");
    },
    async removeSmsStaff(id) {
      this.id = id
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removesmsstaff";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSMSStaffs();
          this.$bvModal.hide("delete-smsstaff");
        }
      });
    },
    async sendtoStaff() {
      let obj = {
        staff: this.StaffCart,
        message: this.msg2,
        sms: this.sms2,
      };
      let url = "/sendtostaff";
      await axios.post(url, obj).then((response) => {
        if (response.status == 200) {
          this.showSmsanalysis();
          this.fetchSMSStaffs();
          this.msg2 = "";
          this.chars2 = "";
          this.sms2 = "";
          this.$toast.success(response.data.message);
        }
      });
    },

    async sendtoOthers() {
      let obj = {
        others: this.contacts,
        message: this.msg3,
        sms: this.sms3,
      };
      let url = "/sendtoother";
      await axios.post(url, obj).then((response) => {
        if (response.status == 200) {
          this.showSmsanalysis();
          this.msg3 = "";
          this.chars3 = "";
          this.sms3 = "";
          this.contacts = []
          this.$toast.success(response.data.message);
        }
      });
    },

    async showSmsanalysis() {
      let url = "/smsanalysis";
      await axios.get(url).then((response) => {
        this.sms_balance = response.data.sms_balance;
        this.membermessages = response.data.membermessages;
        this.staffmessages = response.data.staffmessages;
        this.other_messages = response.data.other_messages;
      });
    },

    addContactTag(event) {
      if (event.key == "Enter" || event.key == ",") {
        let contact = this.contact.slice(0, -1);
        if (contact) {
          this.contacts.push(contact);
          this.contact = "";
        }
      }

      if (event.type == "paste") {
        setTimeout(() => {
          // Use setTimeout to allow the value to update after paste

          // Split the input based on comma or newline and add each contact
          const new_contacts = this.contact
            .split(/[,\\n]/)
            .map((contact) => contact.slice(0, -1))
            .filter((contact) => contact !== "");

          this.contacts = this.contacts.concat(new_contacts);
          this.contact = "";
        });
      }
    },

    removeEmailTag(index) {
      this.contacts.splice(index, 1);
    },

    async getAllMembers() {
      if (this.member_category == 1) {
        let url = 'sms-all-members'
        await axios.get(url).then(response => {
          if (response.status == 200) {
            this.$toast.success(response.data.success);
            this.fetchSMSMembers();
            this.member_category = ''
          } else {
            this.$toast.error(response.data.error)
            this.member_category
          }
        })
      }
    },

    async getAllStaff() {
      if (this.staff_category == 1) {
        let url = 'sms-all-staff'
        await axios.get(url).then(response => {
          if (response.status == 200) {
            this.$toast.success(response.data.success);
            this.fetchSMSStaffs();
          } else {
            this.$toast.error(response.data.error)
          }
        })
      }
    },

    selectMembers(id, event) {
      if (event.target.checked) {
        this.selected_members.push(id)
      } else {
        let index = this.selected_members.indexOf(id);
        if (index !== -1) {
          this.selected_members.splice(index, 1);
        }
      }
    },
  },
};
</script>

<style>
.scrollable-list {
  height: 200px;
  /* Fixed height */
  overflow-y: auto;
  /* Enable vertical scrolling */
  border: 1px solid #ccc;
  padding: 10px;
}

.pb-1 {
  padding-bottom: 0.25rem;
  /* Adjust padding as needed */
}
</style>